<template>
  <div class="main">
    <!-- 팝업 -->
    <div id="popupWrap">
      <a href="javascript:void(0)" class="popupClose" @click=closePopup><i class="ic-close_i"></i></a>
      <div class="contents">
        <swiper class="swiper main_banner" :options="mainBannerOption">
          <swiper-slide v-for="(item, idx) in popups" :key="idx" class="swiper-slide">
            <div class="content" v-html="item.content"></div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="chkToday">
          <p>
            <input type="checkbox" id="chkTodayLb" v-model="chkToday"/>
            <label for="chkTodayLb">하루동안 안보이기</label>
          </p>
        </div>
      </div>
    </div>
    <!-- //팝업 -->

    <MainSlider />
    <div class="wrapper">
      <ProductSlider />
      <GreenBanner />
      <NewProduct />
      <NoticeList class="notice"/>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import http from '@/api/shopBy'
import NoticeList from '@/components/Common/Noticelist.vue';
import MainSlider from '@/components/Main/MainSlider.vue';
import ProductSlider from '@/components/Main/ProductSlider.vue';
import GreenBanner from '@/components/Main/GreenBanner.vue';
import NewProduct from '@/components/Main/NewProduct.vue';
import dayjs from "dayjs";

export default {
  name: 'Main-34bb34',
  components: {
    Swiper,
    SwiperSlide,
    NoticeList,
    MainSlider,
    ProductSlider,
    GreenBanner,
    NewProduct,
  },
  data(){
    return {
      popups: [],
      chkToday: false,
      mainBannerOption: {
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
      },
    }
  },
  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    init() {
      http.get(`/display/popups?pageType=MAIN`)
          .then(({data}) => {
            this.popups = data;
            const cookies = this.getCookies();
            if(this.popups.length > 0) {
              if(cookies['teamstore.tigers.popup']==='done') {
                document.getElementById('popupWrap').style.display = 'none';
              } else {
                document.getElementById('popupWrap').style.display = 'block';
              }
            } else {
              document.getElementById('popupWrap').style.display = 'none';
            }
          })
    },
    closePopup() {
      if(this.chkToday) {
        this.setCookie('teamstore.tigers.popup', 'done');
      }
      document.getElementById('popupWrap').style.display = 'none';
    },
    setCookie(name, value) {
      let today = dayjs().add(1, 'day');
      today = today.format('YYYY-MM-DD 00:00:00');
      today = new Date(today);
      document.cookie = name + '=' + escape(value) + '; path=/; expires = '+ today.toGMTString() + ';';
    },
    getCookies() {
      const cookies = {};
      document.cookie.split(';').forEach(function(cookie) {
        let parts = cookie.split('=');
        cookies[parts[0].trim()] = (parts[1] || '').trim();
      });
      return cookies;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/constants/colors.scss';
@import '@/assets/styles/constants/typography.scss';
.main {
  position: relative;
}
#popupWrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 35px 30px;
  z-index: 9000;
  background: rgba(0, 0, 0, 0.6);

  .popupClose {
    position: absolute;
    top: 35px;
    right: 30px;

    i {
      color: $white;
      font-size: 20px;
    }
  }
  .contents {
    margin-top: 30px;

    text-align: center;

    .swiper {
      background-color: $white;
      border: 1px solid $midBlack;
      img {
        width: 100% !important;
      }
      .swiper-pagination {
        bottom: 15px;
        left: auto;
        right: 15px;
        background-color: $gray-c4;
        padding: 0 10px 2px 10px;
        letter-spacing: -2px;
      }
    }
    .chkToday {
      color: $white;
      text-align: left;

      > p {
        display: inline-block;
        margin-top: 7px;
      }
      label {
        position: relative;
        display: block;
        padding-left: 27px;
        &:before {
          content: '';
          position: absolute;
          top: 2px;
          left: 0;
          display: block;
          width: 20px;
          height: 20px;
          border: 1px solid $midBlack;
          background-color: $white;
          vertical-align: middle;
        }
      }
      input {
        position: absolute;
        top: -9999px;
        left: -9999px;
        font-size: 1px;
        width: 1px;
        height: 1px;

        &:checked + label {
          &:before {
            background: #fff url('@/assets/images/common/ico_checkbox_on.png') no-repeat center/50%;
          }
        }
      }
    }
  }
}
.wrapper {
  padding: 30px 30px 50px;

  .notice {
    margin-top: 40px;
  }
}
/*
.swiper {
  width: 100%;
  //height: 55vh;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #8b8b8b;

  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
}
.swiper-pagination {
  width: 40px;
  border-radius: 15px;
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  font-size: $font-size-13;
  padding: 2px 6px;
  box-sizing: border-box;
}
*/
</style>
